import React from "react";
import {connect} from "react-redux";
import BsForm from "components/form/BsForm";
import {clearPowerLevelHistory, fetchLabelBicycleInfo} from "core/actions/bicycle-actions";
import LABEL_GENERAL_BICYCLE_INFO_FORM from "./label-general-bicycle-info-form";
import BatteryFull from "assets/img/battery_full.png";
import Battery from "assets/img/battery_mid.png";
import BatteryLow from "assets/img/battery_low.png";
import {withTranslation} from "react-i18next";
import PowerLevelHistoryModel from "../../../../../admin/bicycles/info/tabs/info/PowerLevelHistoryModel";
import ConfirmationModel from "components/model/ConfirmationModel";

class LabelGeneralBicycleInfoTab extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      confirmationWindow: {
        open: false,
        message: ''
      },
      powerLevelHistoryWindow: {
        open: false,
        openConfirmation: false
      }
    };

    this.formRef = React.createRef();
    if (!this.props.currentBicycle) {
      this.props.fetchLabelBicycleInfo(this.props.match.params.labelId, this.props.match.params.bicycleId);
    }
  }

  onOpenPowerLevelHistory() {
    this.setState({
      ...this.state,
      powerLevelHistoryWindow: {
        open: true,
        openConfirmation: false
      }
    })
  }

  closePowerLevelHistoryModel() {
    this.setState({
      ...this.state,
      powerLevelHistoryWindow: {
        open: false,
        openConfirmation: false
      }
    })
  }

  onClearPowerLevelHistory() {
    this.setState({
      ...this.state,
      powerLevelHistoryWindow: {
        open: false,
        openConfirmation: true
      }
    });
  }

  onSubmitClearPowerLevelHistory() {
    this.closePowerLevelHistoryModel();
    this.props.clearPowerLevelHistory(this.props.match.params.systemId, this.props.match.params.bicycleId)
  }

  render() {
    if (this.props.currentBicycle) {
      const formConfig = {
        ...LABEL_GENERAL_BICYCLE_INFO_FORM,
        title: {
          back: {
            url: '/label/' + this.props.match.params.labelId + '/bicycles',
            history: this.props.history,
            location: this.props.location
          }
        }
      };

      let showHistoryAction = undefined;
      if (this.props.currentBicycle.powerLevelHistory && this.props.currentBicycle.powerLevelHistory.length > 0) {
        showHistoryAction = this.onOpenPowerLevelHistory
      }

      const {t} = this.props;
      for (let i = 0; i < formConfig.fields.length; i++) {
        if (formConfig.fields[i].name === 'powerLevel') {
          formConfig.fields[i].getValue = (data) => {
            let powerLevel;
            if (!data.lastScan) {
              powerLevel = t('power_level.none');
            }

            const lastScan = new Date(data.lastScan);
            const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

            if (data.powerLevel && expiryScanDate > new Date().getTime()) {
              if (data.powerLevel >= 80) {
                powerLevel = <img src={BatteryFull} alt={data.powerLevel} className="battery-icon"/>
              } else if (data.powerLevel >= 50) {
                powerLevel = <img src={Battery} alt={data.powerLevel} className="battery-icon"/>
              } else if (data.powerLevel < 50) {
                powerLevel = <img src={BatteryLow} alt={data.powerLevel} className="battery-icon"/>
              }
            }

            if (!powerLevel) {
              powerLevel = t('power_level.none');
            }

            if (showHistoryAction) {
              return <span className="cursor-pointer" onClick={showHistoryAction.bind(this)}>{powerLevel}</span>
            }

            return powerLevel;
          };
        }
      }

      const history = this.props.currentBicycle.powerLevelHistory ? this.props.currentBicycle.powerLevelHistory : [];

      return (
          <div className="bs-form-container">
            <ConfirmationModel
              open={this.state.powerLevelHistoryWindow.openConfirmation}
              message="bicycle_info.clear_power_level_history_confirmation_message"
              handleClose={this.closePowerLevelHistoryModel.bind(this)}
              handleApply={this.onSubmitClearPowerLevelHistory.bind(this)}
            />
            <PowerLevelHistoryModel
              open={this.state.powerLevelHistoryWindow.open}
              history={history}
              handleClose={this.closePowerLevelHistoryModel.bind(this)}
              handleClear={this.onClearPowerLevelHistory.bind(this)}
            />

            <BsForm
                config={formConfig}
                formData={this.props.currentBicycle}
                disabled={true}/>
          </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentBicycle: state.bicycle.currentBicycle
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLabelBicycleInfo: (labelId, bicycleId) => {
      dispatch(fetchLabelBicycleInfo(labelId, bicycleId));
    },
    clearPowerLevelHistory: (systemId, bicycleId) => {
      dispatch(clearPowerLevelHistory(systemId, bicycleId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LabelGeneralBicycleInfoTab));
